import type { SubFormBlockConfig } from '@lighthouse/core'

export const generateSubFormBlock = (mainBreakPoint: string): SubFormBlockConfig => {
    return {
        columns: [],
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'auto'
            },
            layout: {},
            design: {}
        },
        breakPoints: []
    }
}
